export default {"breadcrumb":"W7IquG_breadcrumb","page":"W7IquG_page","quiet":"W7IquG_quiet","form":"W7IquG_form","actions":"W7IquG_actions",}